import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import first from '../../assets/images/learn/img3.svg';
import second from '../../assets/images/learn/img2.svg';
import third from '../../assets/images/learn/img1.svg';
import firstone from '../../assets/images/learn/learn1.png';
import secondone from '../../assets/images/learn/learn2.png';
import thirdone from '../../assets/images/learn/learn3.png';
import Paginationn from '../pagination/paginationn';

import './learn_styles/learnlower.css';

export default function LearnLower() {
  return (
    <>
     <Container className='mt-3 mb-3 learn_lower'>
      <Row>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='learn_lower_image'>
            <img src={firstone} alt="first one" className='img-fluid rounded learn_lower_img' />  
          </div>
          <div className='d-flex justify-content-start'>
            <p className='text-justify'>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='learn_lower_image'>
            <img src={secondone} alt="second one" className='img-fluid rounded learn_lower_img' />
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='learn_lower_image'>
            <img src={thirdone} alt="third one" className='img-fluid rounded learn_lower_img' />
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='learn_lower_image'>
            <img src={firstone} alt="first one" className='img-fluid rounded learn_lower_img' />
          </div>
          <div className='d-flex justify-content-start'>
            <p className='text-justify'>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='learn_lower_image'>
            <img src={secondone} alt="second one" className='img-fluid rounded learn_lower_img' />
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <Col lg={4} md={6} className='mt-3'>
          <div className="card">
          <div className='learn_lower_image'>
            <img src={thirdone} alt="third one" className='img-fluid rounded learn_lower_img' />
          </div>
          <div>
            <p>The recently popular Internet AI: ChatGPT has actually written: "The Plan to Destroy Humanity"</p>
          </div>
          <a href="">Detail</a>
          </div>
        </Col>
        <div className="mt-5">
            <Paginationn />
        </div>
      </Row>
     </Container>
    </>
  )
}
